import { toast } from "react-toastify";

import {
  addCreditNoteFailure,
  addCreditNoteStart,
  addCreditNoteSuccess,
  deleteCreditNoteFailure,
  deleteCreditNoteStart,
  deleteCreditNoteSuccess,
  editCreditNoteFailure,
  editCreditNoteStart,
  editCreditNoteSuccess,
  fetchCreditNotePDFFailure,
  fetchCreditNotePDFSuccess,
  fetchCreditNotesFailure,
  fetchCreditNotesStart,
  fetchCreditNotesSuccess,
  getCreditNoteByIdFailure,
  getCreditNoteByIdStart,
  getCreditNoteByIdSuccess,
} from "./reducer";
import {
  addCreditNoteService,
  deleteCreditNoteService,
  editCreditNoteService,
  getCreditNoteByIdService,
  getCreditNotePDFService,
  getCreditNotesListService,
} from "../../Services/creditNoteService";
import Swal from "sweetalert2";

// thunk for fetching the credit note list
export const fetchCreditNotesList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchCreditNotesStart());
      const response = await getCreditNotesListService(params);

      if (params.isPagination === 0) {
        dispatch(
          fetchCreditNotesSuccess({
            creditNotes: response.data, // full list
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          }),
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchCreditNotesSuccess({
            creditNotes: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          }),
        );
      } else {
        dispatch(fetchCreditNotesFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchCreditNotesFailure(error));
    }
  };

// thunk for adding a credit note
export const addCreditNote = (requestParam) => async (dispatch) => {
  try {
    dispatch(addCreditNoteStart());

    const response = await addCreditNoteService(requestParam);

    // if (response?.success) {
    //   toast.success(response.message);
    //
    // } else {
    //   toast.error("Something went wrong");
    //   dispatch(addCreditNoteFailure("Failed to add credit note"));
    // }

    if (!response) {
      await Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Something went wrong while generating the Credit Note",
      });
      return dispatch(addBillInvioceFailure("Failed to generate bill"));
    }

    if (response) {
      const result = await Swal.fire({
        icon: "success",
        title: "Credit Note",
        text: "Credit Note generated successfully. Do you want to download it?",
        showCancelButton: true,
        confirmButtonText: "Yes, Download",
        cancelButtonText: "No, Thanks",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
      });

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (result.isConfirmed) {
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = response?.headers["filename"];
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);

        toast.success(response.message);
        dispatch(addCreditNoteSuccess(response));
      } else {
        // toast.error("Failed to generate Credit Note");
      }
    } else {
      toast.error("Something went wrong ");
      dispatch(addCreditNoteFailure("Failed to generate Credit Note"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(addCreditNoteFailure(error));
  }
};

// thunk for deleting a credit note
export const deleteCreditNote = (creditNoteId) => async (dispatch) => {
  try {
    dispatch(deleteCreditNoteStart());

    const response = await deleteCreditNoteService(creditNoteId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteCreditNoteSuccess(creditNoteId)); // fixed: original used undefined `categoryId`
    } else {
      toast.error("Failed to delete credit note");
      dispatch(deleteCreditNoteFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteCreditNoteFailure(error));
  }
};

// add this service similarly to getCustomersListService

export const fetchCreditNoteById = (id) => async (dispatch) => {
  try {
    dispatch(getCreditNoteByIdStart());
    const response = await getCreditNoteByIdService(id);
    if (response?.data) {
      dispatch(getCreditNoteByIdSuccess(response.data));
    } else {
      dispatch(getCreditNoteByIdFailure("No credit note found"));
    }
  } catch (error) {
    dispatch(getCreditNoteByIdFailure(error));
  }
};

// thunk for updating a credit note
export const updateCreditNote = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(editCreditNoteStart());
    const response = await editCreditNoteService(id, requestParam);

    // if (response?.success) {
    //   toast.success(response.message);
    //   dispatch(editCreditNoteSuccess(response));
    // } else {
    //   dispatch(editCreditNoteFailure("Failed to update credit note"));
    // }

    if (!response) {
      await Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Something went wrong while generating the Credit Note",
      });
      return dispatch(addBillInvioceFailure("Failed to generate bill"));
    }

    if (response) {
      const result = await Swal.fire({
        icon: "success",
        title: "Credit Note",
        text: "Credit Note Edited successfully. Do you want to download it?",
        showCancelButton: true,
        confirmButtonText: "Yes, Download",
        cancelButtonText: "No, Thanks",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
      });

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (result.isConfirmed) {
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = response?.headers["filename"];
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);

        toast.success(response.message);
        dispatch(addCreditNoteSuccess(response));
      } else {
        // toast.error("Failed to edit Credit Note");
      }
    } else {
      toast.error("Something went wrong ");
      dispatch(addCreditNoteFailure("Failed to edit Credit Note"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editCreditNoteFailure(error));
  }
};

export const fetchCreditNotePDFList = (id) => async (dispatch) => {
  try {
    const response = await getCreditNotePDFService(id);

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = response?.headers["filename"];
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    // const pdfBlob = new Blob([response.data], { type: "application/pdf" });

    // const fileURL = window.URL.createObjectURL(pdfBlob);

    // const link = document.createElement("a");
    // link.href = fileURL;
    // link.download = `BillInvoice_${id}.pdf`;
    // link.click();

    // window.URL.revokeObjectURL(fileURL);

    dispatch(fetchCreditNotePDFSuccess("PDF downloaded successfully"));
  } catch (error) {
    dispatch(fetchCreditNotePDFFailure(error));
  }
};
